function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLockOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__lock_1_",
    "data-name": "lock(1)",
    transform: "translate(-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_8735",
    "data-name": "Group 8735",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_4012",
    d: "M81.5 9H80V7a7 7 0 0 0-14 0v2h-1.5a.5.5 0 0 0-.5.5V22a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9.5a.5.5 0 0 0-.5-.5zm-7 10.445A.5.5 0 0 1 74 20h-2a.5.5 0 0 1-.5-.555l.315-2.836A1.978 1.978 0 0 1 71 15a2 2 0 0 1 4 0 1.978 1.978 0 0 1-.818 1.608zM77 9h-8V7a4 4 0 0 1 8 0z",
    "data-name": "Path 4012",
    transform: "translate(-64)",
    style: {
      fill: "#f26b1d"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockOrange);
export default __webpack_public_path__ + "static/media/icon-lock-orange.b437db396619475ca68b129f26729c5a.svg";
export { ForwardRef as ReactComponent };